(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2011,6997],{

/***/ 5336:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),

/***/ 63105:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    baseFilter = __webpack_require__(5336),
    baseIteratee = __webpack_require__(67206),
    isArray = __webpack_require__(1469);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),

/***/ 98606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yt": function() { return /* binding */ LocalizedOurProductFooterLinksV2; },
  "$s": function() { return /* binding */ LocalizedProductsFooterLinks; },
  "kK": function() { return /* binding */ LocalizedProductsHeaderLinks; },
  "nQ": function() { return /* binding */ LocalizedResourcesLinks; },
  "Co": function() { return /* binding */ LocalizedSolutionsFooterLinks; },
  "Rj": function() { return /* binding */ LocalizedUseCasesFooterLinks; },
  "tc": function() { return /* binding */ getLocalizedUri; }
});

// UNUSED EXPORTS: getLocalizedLink

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./constants/localization.js
var localization = __webpack_require__(72632);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./constants/work-managment-logos.js
var work_managment_logos = __webpack_require__(74329);
;// CONCATENATED MODULE: ./client/services/webflow-service/webflow-service.js


var WEBFLOW_PREFIXES = [
    "/ap/",
    "/w/"
];
var _obj;
var WEBFLOW_TO_GENERATOR_PAGE = (_obj = {}, (0,_define_property/* default */.Z)(_obj, links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler, "/work-management"), (0,_define_property/* default */.Z)(_obj, links/* SOFTWARE_MINI_SITE_LINK */.DDD, "/dev"), (0,_define_property/* default */.Z)(_obj, links/* ENTERPRISE_PAGE_LINK */.RVF, "/enterprise"), (0,_define_property/* default */.Z)(_obj, "/w/crm", "/crm"), _obj);
var _obj1;
var WEBFLOW_PAGES_ENABLED_LOCALES = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler, []), (0,_define_property/* default */.Z)(_obj1, links/* SOFTWARE_MINI_SITE_LINK */.DDD, []), (0,_define_property/* default */.Z)(_obj1, links/* ENTERPRISE_PAGE_LINK */.RVF, []), (0,_define_property/* default */.Z)(_obj1, "/w/crm", []), _obj1);
var getWebflowLocalizedPage = function(webflowPage, locale) {
    var _WEBFLOW_PAGES_ENABLED_LOCALES_webflowPage;
    if (!((_WEBFLOW_PAGES_ENABLED_LOCALES_webflowPage = WEBFLOW_PAGES_ENABLED_LOCALES[webflowPage]) === null || _WEBFLOW_PAGES_ENABLED_LOCALES_webflowPage === void 0 ? void 0 : _WEBFLOW_PAGES_ENABLED_LOCALES_webflowPage.includes(locale))) return null;
    var webflowPrefix = WEBFLOW_PREFIXES.find(function(prefix) {
        return webflowPage.startsWith(prefix);
    });
    if (!webflowPrefix) return null;
    var uriWithoutPrefix = webflowPage.slice(webflowPrefix.length);
    return "".concat(webflowPrefix).concat(locale, "/").concat(uriWithoutPrefix);
};
var isWebflowUri = function() {
    var uri = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return WEBFLOW_PREFIXES.some(function(prefix) {
        return uri.startsWith(prefix);
    });
};

;// CONCATENATED MODULE: ./constants/localized-links.js






var SPANISH_HELP_CENTER_LINK = "//support.monday.com/hc/es";
var FRENCH_HELP_CENTER_LINK = "//support.monday.com/hc/fr";
var PORTUGEESE_HELP_CENTER_LINK = "//support.monday.com/hc/es";
var GERMAN_HELP_CENTER_LINK = "//support.monday.com/hc/de";
var JAPANESE_HELP_CENTER_LINK = "//support.monday.com/hc/ja";
var SPANISH_BLOG_LINK = "//monday.com/blog/es/";
var PORTUGEESE_BLOG_LINK = "//monday.com/blog/pt/";
var FRENCH_BLOG_LINK = "//monday.com/blog/fr/";
var GERMAN_BLOG_LINK = "//monday.com/blog/de/";
var JAPANESE_BLOG_LINK = "//monday.com/blog/ja/";
var SPANISH_WORK_OS_LINK = "//monday.com/blog/es/work-os/";
var PORTUGEESE_WORK_OS_LINK = "//monday.com/blog/pt/work-os-uma-plataforma-para-o-futuro-do-trabalho/";
var FRENCH_WORK_OS_LINK = "//monday.com/blog/fr/le-work-os-lavenir-du-travail/";
var localized_links_obj;
var LocalizedResourcesLinks = (localized_links_obj = {}, (0,_define_property/* default */.Z)(localized_links_obj, localization.SPANISH_LOCALE_ID, {
    "header.blog": {
        href: SPANISH_BLOG_LINK
    },
    "header.helpCenter": {
        href: SPANISH_HELP_CENTER_LINK
    },
    "footer.blog": {
        href: SPANISH_BLOG_LINK,
        openInNewTab: true
    },
    "footer.helpCenter": {
        href: SPANISH_HELP_CENTER_LINK,
        openInNewTab: true
    }
}), (0,_define_property/* default */.Z)(localized_links_obj, localization.PORTUGEESE_LOCALE_ID, {
    "header.blog": {
        href: PORTUGEESE_BLOG_LINK
    },
    "header.helpCenter": {
        href: PORTUGEESE_HELP_CENTER_LINK
    },
    "footer.blog": {
        href: PORTUGEESE_BLOG_LINK,
        openInNewTab: true
    },
    "footer.helpCenter": {
        href: PORTUGEESE_HELP_CENTER_LINK,
        openInNewTab: true
    }
}), (0,_define_property/* default */.Z)(localized_links_obj, localization.FRENCH_LOCALE_ID, {
    "header.blog": {
        href: FRENCH_BLOG_LINK
    },
    "header.helpCenter": {
        href: FRENCH_HELP_CENTER_LINK
    },
    "footer.blog": {
        href: FRENCH_BLOG_LINK,
        openInNewTab: true
    },
    "footer.helpCenter": {
        href: FRENCH_HELP_CENTER_LINK,
        openInNewTab: true
    }
}), (0,_define_property/* default */.Z)(localized_links_obj, localization.GERMAN_LOCALE_ID, {
    "header.blog": {
        href: GERMAN_BLOG_LINK
    },
    "header.helpCenter": {
        href: GERMAN_HELP_CENTER_LINK
    },
    "footer.blog": {
        href: GERMAN_BLOG_LINK,
        openInNewTab: true
    }
}), (0,_define_property/* default */.Z)(localized_links_obj, localization.JAPANESE_LOCALE_ID, {
    "header.blog": {
        href: JAPANESE_BLOG_LINK
    },
    "header.helpCenter": {
        href: JAPANESE_HELP_CENTER_LINK
    },
    "footer.blog": {
        href: JAPANESE_BLOG_LINK,
        openInNewTab: true
    }
}), localized_links_obj);
var DEFAULT_LINKS = {
    "header.blog": {
        href: "//monday.com/blog"
    }
};
var localized_links_obj1;
var LocalizedOurProductFooterLinksV2 = (localized_links_obj1 = {}, (0,_define_property/* default */.Z)(localized_links_obj1, localization.SPANISH_LOCALE_ID, {
    "footer.workOS": SPANISH_WORK_OS_LINK
}), (0,_define_property/* default */.Z)(localized_links_obj1, localization.PORTUGEESE_LOCALE_ID, {
    "footer.workOS": PORTUGEESE_WORK_OS_LINK
}), (0,_define_property/* default */.Z)(localized_links_obj1, localization.FRENCH_LOCALE_ID, {
    "footer.workOS": FRENCH_WORK_OS_LINK
}), localized_links_obj1);
var getGeneratorLocalizedUri = function() {
    var uri = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", localeId = arguments.length > 1 ? arguments[1] : void 0;
    return "/lang/".concat(localeId).concat(uri);
};
// For links referring to Webflow pages, we use the old Generator pages for most locales.
// The localized format differs between the two platforms.
var getLocalizedUri = function() {
    var uri = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", localeId = arguments.length > 1 ? arguments[1] : void 0;
    if (!localeId || localeId === localization.ENGLISH_LOCALE_ID) return uri;
    if (!isWebflowUri(uri)) return getGeneratorLocalizedUri(uri, localeId);
    var webflowLocalizedPage = getWebflowLocalizedPage(uri, localeId);
    if (webflowLocalizedPage) return webflowLocalizedPage;
    var generatorAnalogousPage = WEBFLOW_TO_GENERATOR_PAGE[uri];
    if (generatorAnalogousPage) return getGeneratorLocalizedUri(generatorAnalogousPage, localeId);
    return uri;
};
// TODO: Temp solution until we refactor the whole footer and header localization mechanism
// for WM Generator vs. Webflow mini site test
var LocalizedProductsHeaderLinks = localization.SUPPORTED_LOCALE_IDS.reduce(function(acc, localeId) {
    acc[localeId] = {
        // Products
        "header.tabs.products.mondayWorkManagement.title": getLocalizedUri(links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler, localeId),
        "header.tabs.products.mondaySalesCRM.title": getLocalizedUri(links/* CRM_MINI_SITE_LINK */.mgz, localeId),
        "header.tabs.products.mondayDev.title": getLocalizedUri(links/* SOFTWARE_MINI_SITE_LINK */.DDD, localeId),
        // Switcher
        "header.tabs.solutions.byProduct.workManagement": getLocalizedUri(links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler, localeId),
        "header.tabs.solutions.byProduct.crm": getLocalizedUri(links/* CRM_MINI_SITE_LINK */.mgz, localeId),
        "header.tabs.solutions.byProduct.dev": getLocalizedUri(links/* SOFTWARE_MINI_SITE_LINK */.DDD, localeId),
        // Solutions by team
        "header.tabs.solution.sales": getLocalizedUri(links/* CRM_MINI_SITE_LINK */.mgz, localeId),
        "header.tabs.solution.product": getLocalizedUri(links/* SOFTWARE_MINI_SITE_LINK */.DDD, localeId),
        "header.tabs.solution.rnd": getLocalizedUri(links/* SOFTWARE_MINI_SITE_LINK */.DDD, localeId),
        // Solutions by Company Size
        "header.tabs.solution.enterprise": getLocalizedUri(links/* ENTERPRISE_OLD_PAGE_LINK */.Bhn, localeId)
    };
    return acc;
}, {});
var LocalizedProductsFooterLinks = localization.SUPPORTED_LOCALE_IDS.reduce(function(acc, localeId) {
    acc[localeId] = {
        "footer.mondayWorkManagement": {
            href: getLocalizedUri(links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler, localeId),
            icon: work_managment_logos/* default.WM_FOOTER_LOGO */.Z.WM_FOOTER_LOGO
        },
        "footer.mondaySalesCRM": {
            href: getLocalizedUri(links/* CRM_MINI_SITE_LINK */.mgz, localeId),
            icon: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/footer/crm_icon_footer.png"
        },
        "footer.mondayDev": {
            href: getLocalizedUri(links/* SOFTWARE_MINI_SITE_LINK */.DDD, localeId),
            icon: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/footer/dev_new_mobile_footer_logo.png"
        }
    };
    return acc;
}, {});
var LocalizedUseCasesFooterLinks = localization.SUPPORTED_LOCALE_IDS.reduce(function(acc, localeId) {
    acc[localeId] = {
        "footer.salesUseCase": getLocalizedUri(links/* CRM_MINI_SITE_LINK */.mgz, localeId),
        "footer.developers": getLocalizedUri(links/* SOFTWARE_MINI_SITE_LINK */.DDD, localeId)
    };
    return acc;
}, {});
var LocalizedSolutionsFooterLinks = localization.SUPPORTED_LOCALE_IDS.reduce(function(acc, localeId) {
    acc[localeId] = {
        "footer.enterprise": getLocalizedUri(links/* ENTERPRISE_OLD_PAGE_LINK */.Bhn, localeId)
    };
    return acc;
}, {});
// SUPPORTED_LOCALE_IDS
var getLocalizedLink = function(link, localeId) {
    var _DEFAULT_LINKS_link;
    var localizedLinks = LocalizedResourcesLinks[localeId];
    return localizedLinks && localizedLinks[link] ? localizedLinks[link].href : ((_DEFAULT_LINKS_link = DEFAULT_LINKS[link]) === null || _DEFAULT_LINKS_link === void 0 ? void 0 : _DEFAULT_LINKS_link.href) || link;
};


/***/ }),

/***/ 73022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ RegularHeaderComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var segments_desktop_header_layouts_base_header_base_header_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33782);




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



var RegularHeaderComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(RegularHeaderComponent, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(RegularHeaderComponent);
    function RegularHeaderComponent() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, RegularHeaderComponent);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(RegularHeaderComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "regular-header-component",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(segments_desktop_header_layouts_base_header_base_header_component__WEBPACK_IMPORTED_MODULE_2__["default"], _object_spread({}, this.props))
                });
            }
        }
    ]);
    return RegularHeaderComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);

RegularHeaderComponent.defaultProps = {
    showMenu: true,
    shortHeader: false
};


/***/ })

}]);